import { ApiPath } from "enums";
import { Get } from "utils";

export const getStationPricing = async (query) => {
  const res = await Get(`${ApiPath.StationPricing}`, { ...query, orderBy: "capturedAt" });
  return res.data;
};
